import { useQuery } from "react-query";
import { getCategories } from "../../../MyApi/product/categories";

const CategoriesFilter = ({filters, handleChange}) => {
  const { data, isLoading, isError } = useQuery(
   [ "getCategories" ,filters?.store_id],  
  ()=>getCategories(filters?.store_id)
  );

  const categories = data?.data?.categories || [];
  

  if (isError) return <p>Failed to load categories</p>;

  return (
    <div className="col-md-3 add">
      <select name="category_id" className="form-control" value={filters.category_id}  onChange={(e)=>handleChange("category_id",e.target.value)}>
        <option value="">الفئات</option>

        {categories.map((category) => (
          <option key={category.id} value={category.id}>
            {category.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CategoriesFilter;
